var _line, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboarding1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 14,
    viewBox: "0 0 48 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6.5,
    x2: 44,
    y2: 6.5,
    stroke: "#E6ECFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#3733FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 6.5,
    r: 4.5,
    fill: "#CCDAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding1);
export default __webpack_public_path__ + "static/media/onboarding1.e66291ae51ce2ecb1b4b401ccc7469aa.svg";
export { ForwardRef as ReactComponent };